import src from "IMAGE";
export default { src, width: 104, height: 104, blurWidth: 0, blurHeight: 0};
